import { memo, useState, useEffect } from "react";
import { Col, Divider, Row, List, Button } from "antd";
import styled from "styled-components";
import { CloudUploadOutlined, EditOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { selectorDataProject } from "../../redux/selector";
import { putDataInfoRevenue } from "../../redux/Future/Common/action";

function ProjectInformation({ id = 3 }) {
  const [isEditInfor, setIsEditInfor] = useState(false);
  const [data, setData] = useState({
    description: "",
    id: 0,
    pa: "",
    pm: "",
    project_name: "",
    tester: "",
  });
  const dispatch = useDispatch();
  const { users = [] } = useSelector(selectorDataProject) || [];

  useEffect(() => {
    const filterData = users.filter((item) => +item.id === id) || [];
    setData(filterData[0] || {});
  }, [users]);

  const handleChangeData = (e = {}, title) => {
    // const newData = { ...data };
    // newData[title] = e.target?.value;
    // setData(newData);
    setData((prevData) => ({ ...prevData, [title]: e.target?.value }));
  };

  const handleEdit = () => {
    // console.log(isEditInfor);
    if (isEditInfor) {
      dispatch(putDataInfoRevenue(data));
    }
    setIsEditInfor(!isEditInfor);
  };

  return (
    <Container>
      <div className="container-btn-edit">
        <Button
          onClick={handleEdit}
          className={isEditInfor ? "btn-update" : "btn-edit"}
        >
          {isEditInfor ? (
            <span>
              <CloudUploadOutlined />
              &nbsp;&nbsp;Update
            </span>
          ) : (
            <span>
              <EditOutlined />
              &nbsp;&nbsp;Edit
            </span>
          )}
        </Button>
      </div>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row" span={8} lg={8} xs={12}>
          <Divider orientation="left">Project Name </Divider>
          <List
            header={
              <input
                value={data.project_name}
                placeholder="Project Name"
                className="input-item"
                disabled={!isEditInfor}
                onChange={(e) => handleChangeData(e, "project_name")}
              />
            }
            bordered
            dataSource={[""]}
          />
        </Col>
        <Col className="gutter-row" span={8} lg={8} xs={12}>
          <Divider orientation="left">PM </Divider>
          <List
            // header={<div className="header">{data.pm}</div>}
            header={
              <input
                value={data.pm}
                placeholder="PM"
                className="input-item"
                disabled={!isEditInfor}
                onChange={(e) => handleChangeData(e, "pm")}
              />
            }
            bordered
            dataSource={[""]}
          />
        </Col>
        <Col className="gutter-row" span={8} lg={8} xs={12}>
          <Divider orientation="left">PA </Divider>
          <List
            // header={<div className="header">{data.pa}</div>}
            header={
              <input
                value={data.pa}
                placeholder="PA"
                className="input-item"
                disabled={!isEditInfor}
                onChange={(e) => handleChangeData(e, "pa")}
              />
            }
            bordered
            dataSource={[""]}
          />
        </Col>
        <Col className="gutter-row" span={8} lg={8} xs={12}>
          <Divider orientation="left">Tester </Divider>
          <List
            // header={<div className="header">{data.tester}</div>}
            header={
              <input
                className="input-item"
                value={data.tester}
                placeholder="Tester"
                disabled={!isEditInfor}
                onChange={(e) => handleChangeData(e, "tester")}
              />
            }
            bordered
            dataSource={[""]}
          />
        </Col>
        <Col className="gutter-row" span={8} lg={8} xs={12}>
          <Divider orientation="left">Description </Divider>
          <List
            // header={<div className="header">{data.description}</div>}
            header={
              <input
                value={data.description}
                placeholder="Description"
                className="input-item"
                disabled={!isEditInfor}
                onChange={(e) => handleChangeData(e, "description")}
              />
            }
            bordered
            dataSource={[""]}
          />
        </Col>
      </Row>
    </Container>
  );
}
export default memo(ProjectInformation);
const Container = styled.div`
  margin-bottom: 1.5rem;
  :where(
      .css-dev-only-do-not-override-amq5gd
    ).ant-divider-horizontal.ant-divider-with-text {
    margin-bottom: 5px;
    margin-top: 25px;
  }

  .btn-update {
    background-color: #3498db;
    color: white;

    &:hover {
      background-color: white;
      color: #3498db;
    }
  }

  .input-item {
    width: 100%;
    height: 100%;
    border: 0px;
    background: white;
  }

  .container-btn-edit {
    width: 100%;
    position: relative;
    height: 10px;
    z-index: 9;

    button {
      position: absolute;
      right: 0;
      display: flex;
      align-items: center;
    }
  }

  @media (max-width: 768px){
    .ant-list-header{
      padding-inline: 5px !important;

      input{
        font-size: 13px !important;
      }
    }
  }
`;
